import { useLanguage } from "../contexts/LanguageContext";
import { getTranslation } from "../utils/translations";

/**
 * React hook to use translations with context support
 * This hook will trigger re-renders when language changes
 * 
 * @returns {Function} Translation function that takes a key and returns translated text
 * 
 * @example
 * const t = useTranslation();
 * <button>{t('common.save')}</button>
 */
export const useTranslation = () => {
  const { language } = useLanguage();
  return (key) => getTranslation(key, language);
};

